import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const finish = useCallback((data) => {
    localStorage.setItem("kc_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const login = useCallback(async (email, password) => finish((await api.post("/auth/login", { email, password })).data), [finish]);
  const register = useCallback(async (payload) => finish((await api.post("/auth/register", payload)).data), [finish]);
  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("kc_token");
    setUser(false);
  }, []);
  const refreshMe = useCallback(async () => { const r = await api.get("/auth/me"); setUser(r.data); }, []);

  return <AuthContext.Provider value={{ user, login, register, logout, refreshMe }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
